export default __webpack_public_path__ + "static/media/cors.a942f81e.png";